import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddTreatmentModalService } from '@libs/charting';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryListModule, InputComponent, TooltipModule, AddTreatmentItem } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { DataState } from '@libs/utils';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { Store } from '@ngrx/store';
import { selectSiteSettingsPmsType } from '@libs/store';
import { PmsType } from '@ffd/api-client';
import { ReasonSelectorModalService } from '../reason-selector-modal.service';

@Component({
  selector: 'lib-other-codes',
  imports: [CommonModule, SvgIconComponent, InputComponent, TranslateModule, LottieComponent, CategoryListModule, TooltipModule],
  templateUrl: './other-codes.component.html',
  styleUrl: './other-codes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtherCodesComponent {
  public readonly addTreatmentModalService = inject(AddTreatmentModalService);
  private readonly reasonSelectorModalService = inject(ReasonSelectorModalService);
  private readonly store = inject(Store);

  private readonly pmsType = this.store.selectSignal(selectSiteSettingsPmsType);
  private readonly isOpenDental = computed(() => this.pmsType() === PmsType.OPEN_DENTAL);

  protected allClassifications = computed(() => this.addTreatmentModalService.viewModel().classifications);
  protected classificationsForOpenDental = computed(() => this.addTreatmentModalService.viewModel().classificationsForOpenDental);
  protected classifications = computed(() => (this.isOpenDental() ? this.classificationsForOpenDental() : this.allClassifications()));

  protected allSelectedClassification = computed(() => this.addTreatmentModalService.viewModel().selectedClassification);
  protected selectedClassificationForOpenDental = computed(
    () => this.addTreatmentModalService.viewModel().selectedClassificationsForOpenDental,
  );
  protected selectedClassification = computed(() =>
    this.isOpenDental() ? this.selectedClassificationForOpenDental() : this.allSelectedClassification(),
  );

  public searchQuery = this.addTreatmentModalService.selectSignal((state) => state.searchQuery);

  public selectedReasons = this.reasonSelectorModalService.selectedReasons;

  protected readonly DataState = DataState;

  protected readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  protected onSearchQueryChange(searchQuery: string): void {
    this.addTreatmentModalService.setSearchQuery(searchQuery);
  }

  protected onClassificationClick(classificationId: string): void {
    this.addTreatmentModalService.setSelectedClassificationId(classificationId);
  }

  public isSelected(item: AddTreatmentItem): boolean {
    return this.selectedReasons().some((selected) => selected.progressNoteId == null && selected.code === item.dentalCode);
  }

  protected selectItem(item: AddTreatmentItem): void {
    this.reasonSelectorModalService.addReason({
      abbreviation: item.abbreviation || item.description,
      code: item.dentalCode,
      name: item.description,
    });
  }

  protected deselectItem(item: AddTreatmentItem): void {
    this.reasonSelectorModalService.removeReason(item.dentalCode);
  }
}
